import axios from '@/plugins/axios'
import type { ApiResponse, Notification } from '@/types/global'
import { context } from '.'

export const fetchNotifications = async (page = 1, limit = 10) => {
  const { data } = await axios.post<ApiResponse<Notification[]>>(
    `/api-proxy/onesignal/${import.meta.env.VITE_API_VERSION}/fetch`,
    {
      jsonrpc: '2.0',
      params: {
        page,
        limit,
        order: 'date desc'
      }
    }
  )
  return data.result
}

export const markNotificationAsSeen = async (recordId: number) => {
  const { data } = await axios.post<ApiResponse<{ is_seen: boolean }>>(
    `/api-proxy/onesignal/${import.meta.env.VITE_API_VERSION}/set_seen`,
    {
      jsonrpc: '2.0',
      params: {
        record_id: recordId
      }
    }
  )
  return data.result
}
